<template>
    <div class="position-relative">
        <div class="card mt-2">
            <div class="card-body atenciones-page">
                <div class="atenciones-head">
                    <div>
                        <h6>Atenciones del día</h6>
                        <p>{{ pacientesConsulta.length }} en espera</p>
                    </div>
                    <button type="button" class="btn-refrescar-atencion" @click="loadAtencionesYsignosVitales"
                        aria-label="Actualizar listado">
                        <i class="fas fa-sync"></i>
                    </button>
                </div>

                <div class="atenciones-tabla">
                    <DataTable :columns="columns" :options="options" :data="pacientesConsulta"
                        class="table tablesorter atenciones-table" width="100%">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha/Hora</th>
                                <th>Código</th>
                                <th data-priority="1">Paciente</th>
                                <th data-priority="2">Especialidad</th>
                                <th data-priority="3">Doctor</th>
                                <th style="text-align: center!important;">Acción</th>
                            </tr>
                        </thead>


                    </DataTable>
                </div>
            </div>
        </div>
        <!-- Botón flotante -->
        <button v-on:click="showAlert()" class="btn btn-primary btn-floating bell-button"
            :class="{ active: isRinging }">
            <i style="font-size: 25px; color: yellow;" class="fas fa-bell"></i>
        </button>
    </div>
</template>

<script>
/* eslint-disable */
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
DataTable.use(DataTablesCore);


export default {
    name: "Atenciones",
    components: {
        DataTable
    },

    data() {
        let datos = JSON.parse(localStorage.getItem("userData"));

        return {
            isRinging: false,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            user: datos.email,
            pacientesConsulta: [],

            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                {
                    data: 'signos_vitales.date_at',
                    render: function (data, type) {
                        if (!data) return '';
                        const fechaHora = new Date(data);
                        if (Number.isNaN(fechaHora.getTime())) return '';
                        const fechaFormateada = fechaHora.toLocaleDateString('es-EC', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        });
                        const horaFormateada = fechaHora.toLocaleTimeString('es-EC', {
                            hour12: false,
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        if (type && type !== 'display') return `${fechaFormateada} ${horaFormateada}`;
                        return `<div class="atencion-fecha"><span>${fechaFormateada}</span><small>${horaFormateada}</small></div>`;
                    }
                },
                { data: 'codigo_consulta' },
                {
                    data: null,
                    render: (data, type) => {
                        const nombre = data.nombres_pacientes || '';
                        if (type && type !== 'display') return nombre;
                        const cedula = data.cedula || '';
                        return `
                            <div class="atencion-persona">
                                <span class="atencion-nombre">${nombre}</span>
                                <span class="atencion-cedula">${cedula}</span>
                            </div>
                        `;
                    }
                },
                { data: 'name_especialidad' },
                { data: 'doctor' },
                {
                    data: null,
                    render: function (data, type, row) {
                        const dataObject = encodeURIComponent(JSON.stringify(row)); // Codificar el JSON
                        return `
                                <div class="d-flex justify-content-center align-items-center gap-2">
                                    <button class="btn btn-sm btn-atender" data-id="${dataObject}" data-action="atender">
                                        <i class="dataAtencion fa-solid fa-stethoscope me-2"></i>
                                        Atender
                                    </button>
                                    <button class="btn btn-sm btn-ausente" data-id="${dataObject}" data-action="ausente">
                                        <i class="fa-solid fa-user-slash me-2"></i>
                                        Ausente
                                    </button>
                                </div>
                            `;
                    }
                }
            ],
            options: {
                searching: false,
                responsive: true,
                autoWidth: false,
                lengthChange: false,
                "ordering": false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: 4 }
                ],
                lengthMenu: [
                    [5, 15, 25, 35, 50, -1],
                    [5, 15, 25, 35, 50, "All"],
                ],
                pageLength: 15,
                "language": {
                    "search": "Buscar:",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "searchPlaceholder": "Ingrese algún dato",
                    "zeroRecords": "Lo sentimos, no se encontraron resultados",
                    "processing": "Buscando. Espere por favor...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },

                }
            },

        };
    },
    computed: {},
    watch: {},

    activated() {
        this.handleNewInsert()
    },

    beforeUnmount() {
        // Dejar de escuchar el evento cuando el componente se desmonta
        this.$eventBus.off('new_insert', this.handleNewInsert);

    },

    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        // Escuchar el evento global 'new_insert'
        this.$eventBus.on('new_insert', this.handleNewInsert);

        // Escuchar clics en los botones de "Atender"
        document.addEventListener("click", this.handleAtenderClick);
    },

    methods: {
        showAlert() {
            if (this.isRinging) return
            this.isRinging = true

            this.$https.post('/consulta/getSonidoAlerta', { email: this.user }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (response.data.code === 200) {
                    // El sonido en TV llega por WebSocket; aquí solo confirmamos el envío
                    this.showSuccessToast(response.data.message || 'Alerta enviada correctamente')
                } else {
                    this.showErrorMejor(response.data.message || 'Error al enviar la alerta')
                }
            }).catch(error => {
                console.error('Error al enviar la alerta:', error)
                this.showErrorMejor(error?.response?.data?.message || 'Error al enviar la alerta')
            }).finally(() => {
                setTimeout(() => {
                    this.isRinging = false
                }, 500)
            })
        },

        handleNewInsert() {
            this.loadAtencionesYsignosVitales(); // Recargar los datos
        },

        loadAtencionesYsignosVitales() {

            this.pacientesConsulta = []

            this.$https.post('/consulta/getLoadTicketAtencion', { email: this.user }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {
                    this.pacientesConsulta = response.data.datos; // Devuelve los datos
                }
            }).catch(error => {


                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }

                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                }
                throw error; // Relanza el error para manejarlo en el componente
            });
        },


        async clienteAusente(data) {

            const title = "¿Estas seguro que el paciente está ausente?";
            const textButton = "Si. Está ausente";

            this.$swal({
                title: title,
                html: '',
                icon: "question",
                width: "500px",
                showCancelButton: true,
                //input: "text",
                //inputPlaceholder: "Motivo del rechazo de solicitud",
                /* inputAttributes: {
                    autocapitalize: "off",
                } */
                confirmButtonText: textButton,
                cancelButtonText: "Cancelar",
                allowEscapeKey: true,
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-secondary ml-1",
                },
                buttonsStyling: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {

                }

            }).then(async (result) => {
                if (result.isConfirmed) {

                    this.showLoading()

                    try {

                        const response = await this.$https.post("/consulta/getUpdatePacientesAusentes", { codigo: data }, { headers: { Authorization: this.tokenAuth } });

                        if (response.data.code === 200) {
                            const datos = response.data.message;

                            this.showOk(datos)
                        }

                    } catch (error) {
                        if (error.response.status === 400) {
                            this.showErrorMejor(error.response.data.message)
                        }
                        if (error.response.status === 401) {
                            this.showSessionExpiredAlert()
                        }
                    } finally {

                        this.hideLoading();

                    }






                }
            })



        },


        handleAtenderClick(event) {

            // Función auxiliar para obtener los datos del botón
            const getButtonData = (button) => {
                const dataString = button.getAttribute("data-id");
                const actionType = button.getAttribute("data-action");
                try {
                    const data = JSON.parse(decodeURIComponent(dataString)); // Decodificar y parsear JSON
                    return { data, actionType };
                } catch (e) {
                    console.error("Error al parsear el JSON:", e);
                    return null;
                }
            };

            // Verificar si el clic fue en un botón de "Atender"
            const atenderButton = event.target.closest(".btn-atender");
            if (atenderButton) {
                const buttonData = getButtonData(atenderButton);
                if (buttonData && buttonData.actionType === "atender") {
                    const { data } = buttonData;

                    // Navegar a la ruta de atención
                    this.$router.push({
                        name: 'dashboardAtencion',
                        query: {
                            cod_paciente: data.cod_paciente,
                            cod_consulta: data.codigo_consulta,
                            idPaciente: data.id
                        }
                    });
                }
            }

            // Verificar si el clic fue en un botón de "Ausente"
            const ausenteButton = event.target.closest(".btn-ausente");
            if (ausenteButton) {
                const buttonData = getButtonData(ausenteButton);
                if (buttonData && buttonData.actionType === "ausente") {
                    const { data } = buttonData;
                    this.clienteAusente(data.codigo_consulta);
                }
            }
        },


    }
};
</script>

<style>
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';

.atenciones-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.atenciones-head h6 {
    margin: 0;
    color: #1f2a37;
    font-weight: 700;
}

.atenciones-head p {
    margin: 2px 0 0;
    color: #6b7c8f;
    font-size: 0.78rem;
}

.btn-refrescar-atencion {
    width: 34px;
    height: 34px;
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    background: #fff;
    color: #0078be;
}

.atenciones-tabla {
    border: 1px solid #e6edf5;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}

.atenciones-tabla .dataTables_wrapper {
    padding: 0 0 8px;
}

.atenciones-tabla table.atenciones-table {
    margin: 0 !important;
    font-size: 0.84rem;
    color: #1f2a37;
}

.atenciones-tabla table.atenciones-table thead th {
    padding: 12px 10px;
    border-bottom: 1px solid #e6edf5 !important;
    background: #f4f8fb;
    color: #4b5d6e;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.atenciones-tabla table.atenciones-table tbody td {
    padding: 11px 10px;
    border-bottom: 1px solid #eef2f6;
    vertical-align: middle;
}

.atenciones-tabla table.atenciones-table tbody tr:hover td {
    background: #f3f9fd;
}

.atencion-fecha,
.atencion-persona {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.atencion-nombre {
    font-weight: 700;
    line-height: 1.2;
}

.atencion-fecha small,
.atencion-cedula {
    color: #6b7c8f;
    font-size: 0.75rem;
}

.atenciones-tabla .dataTables_info,
.atenciones-tabla .dataTables_paginate {
    padding: 8px 12px;
    color: #6b7c8f;
    font-size: 0.75rem;
}

.atenciones-tabla .dataTables_paginate .paginate_button {
    margin: 0 2px;
    border: 1px solid #e3eaf2 !important;
    border-radius: 8px !important;
    background: #fff !important;
    color: #0078be !important;
}

.atenciones-tabla .dataTables_paginate .paginate_button.current {
    background: #0078be !important;
    border-color: #0078be !important;
    color: #fff !important;
}

/* Estilos personalizados para el botón "Atender" */
.btn-atender {
    background-color: #eb1265;
    /* Color de fondo */
    color: white;
    /* Color del texto */
    border: none;
    /* Sin borde */
    padding: 5px 10px;
    /* Espaciado interno */
    border-radius: 5px;
    /* Bordes redondeados */
    font-size: 12px;
    /* Tamaño de fuente */
    transition: background-color 0.3s ease, color 0.3s ease;
    /* Transición suave */
}

.btn-atender:hover,
.btn-ausente:hover {
    background-color: #c40e55;
    /* Cambia el color de fondo al pasar el mouse */
    color: white !important;
    /* Cambia el color del texto al pasar el mouse */
}

.btn-atender i,
.btn-ausente i {
    margin-right: 5px;
    /* Espacio entre el ícono y el texto */
}

.btn-floating {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-size: 1.25rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    transition: all 0.3s ease;
}

.btn-floating:hover {
    transform: scale(1.1) translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.bell-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease-in-out;
}

.bell-button.active {
    animation: ring 0.5s ease-in-out;
}

@keyframes ring {
    0% {
        transform: rotate(0);
    }

    20% {
        transform: rotate(-10deg);
    }

    40% {
        transform: rotate(10deg);
    }

    60% {
        transform: rotate(-10deg);
    }

    80% {
        transform: rotate(10deg);
    }

    100% {
        transform: rotate(0);
    }
}

@media (max-width: 768px) {
    .btn-floating {
        bottom: 20px;
        right: 20px;
        width: 50px;
        height: 50px;
    }
}
</style>